import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./LandingPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { Link  } from 'react-router-dom';
import  Carousel  from "../../Desktop/LandingPage/rcarousel";
import CostEstimate from "../../Common/CostEstimateForm"
// import  Carousel  from "../../Desktop/LandingPage/carousel";
import {home_page} from "../../data";
import ProjectCard from "../../Common/Tab";
import CardCarousel from "../../Common/Testimonials";
import MultiCarousel from "../../Common/LogoCarousel";
import PackageTab from "../../Common/PackageTab";


function App() {
  return (
    <div className="lpt-container-center-horizontal">
      <div className="lpt-x01-landing-pagetablet lpt-screen">
      <NavBar/>
        <div className="lpt-overlap-group-1">
          <Carousel/>
        </div>
        <div style={{position:'relative', display: 'flex', flexDirection: 'column',alignItems:'center'}}>
        <div className="lpt-packages lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">Packages</div>
        <p className="lpt-text-19 lpt-typographybody16-regular">
          We offer an entire array of construction options. Choose from basic to luxury according to your requirements
        </p>
        <div className="lpt-frame-158">
          <PackageTab/>
        </div>
        </div>

        <div style={{position:'relative', display: 'flex', flexDirection: 'column',alignItems:'center',width:'100%',height:'500px'}}>
        <div className="lpt-overlap-group1">
          <div className="lpt-frame-162">
            <div className="lpt-overlap-group2-8">
              <div className="lpt-cost-estimator-bg">
                <div className="lpt-rectangle-63"></div>
              </div>
              <Group11422
                costEstimator="Cost Estimator"
                text93="Our very own software infused with years of experience. Use it to find a probable cost estimation to help you make a better choice"
              />
              <EstimateNowButton>ESTIMATE NOW</EstimateNowButton>
              <Group11722 frame12Props={group11722Data.frame12Props} frame122Props={group11722Data.frame122Props} />
            </div>
          </div>
        </div>
       </div>
       <div id= "whyWebuild"></div>
        <div style={{position:'relative', display: 'flex', flexDirection: 'column',alignItems:'center'}}>
          <div className="lpt-why-webuild lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">Why Webuildd?</div>
          <p className="lpt-text-1-2 lpt-typography-body-smalltext-14-regular">
          Because we bring to the table over 40 years of comprehensive experience, over 100 happy customers blended with trust, reliability and transparency
          </p>
        </div>
        <div style={{position:'relative', display: 'flex', flexDirection: 'column',alignItems:'center'}}>
        <div className="lpt-group-144">
          <img
            className="lpt-rectangle-7"
            src={home_page.WhyWebuild1}
            alt="The Webuildd Difference"
          />
          <div className="lpt-group-143">
            <div className="lpt-building">
              <div className="lpt-overlap-group2-5">
                <div className="lpt-group-2"></div>
              </div>
            </div>
            <div className="lpt-text-2-1 lpt-valign-text-middle lpt-typographyheadlineh5-extrabold-20">The Webuildd Difference</div>
            <p className="lpt-text-3 lpt-typographybodysmall-12-regular">
              <span className="lpt-span lpt-typographybodysmall-12-regular">
                What makes us stand miles apart from other firms? We call it “Webuildd Difference”: from the very first
                time you meet us, to the interaction with our team, the hassle-free engagement and finally the day we
                hand you the keys to your new home/building, the only standard we accept for ourselves (and our
                customers) is “Consistent Excellence”. We are never satisfied with our laurels, and our service to you
                goes far beyond simply putting one brick on top of another. We not only ensure that get quality, but
                also blend it with creativity, engineering, management, quality and multiple other disciplines to
                deliver the perfect output for your residential or commercial needs. We have even created our very own
              </span>
              <span className="lpt-span-1 lpt-typographybodysmall-12-regular">
                {" "}
                <br />
              </span>
              <span className="lpt-span2-1 lpt-overpass-semi-bold-mahogany-12px">cost estimator</span>
              <span className="lpt-span-1 lpt-typographybodysmall-12-regular">&nbsp;</span>
              <span className="lpt-span lpt-typographybodysmall-12-regular">
                that helps you calculate your probable capital outgo for your upcoming building. We really like to make
                things easy for our clients
              </span>
            </p>
          </div>
        </div>
        <div className="lpt-group-142">
          <img
            className="lpt-rectangle-7"
            src={home_page.WhyWebuild2}
            alt="Webuildd, Minimum Hassles, Maximum Value"
          />
          <div className="lpt-group-145">
            <div className="lpt-blueprint">
              <div className="lpt-overlap-group2-6">
                <img
                  src={home_page.BluePrint} width='40px' height='40px'
                />
              </div>
            </div>
            <div className="lpt-text-4 lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">
              Why Choose Us? Minimum Hassles. Maximum Value
            </div>
            <p className="lpt-text-5 lpt-typography-body-smalltext-14-regular">
              We possess third generation business continuity which is a rarity. Which means that you gain decades of
              collaborative experience to your benefit. Expertise, quality, transparency, reliability and cost
              effectiveness are why our customers come back to us again and again. We offer a perfect blend of all these
              factors resulting in deep customer delight. We put the “Smart” in everything that we do. Smarter design,
              smarter spaces, smarter value. Simply: smarter living. With exciting options and construction plans to
              choose from, one is certain to be right for you. Yes, other people do some of what we do, but no one does
              everything in the unique way we do.
            </p>
          </div>
        </div>
        <img
          className="lpt-rectangle-70"
          src={home_page.WhyWebuild3}
          alt="Webuildd Customer Value Propositions"
        /> 
        <div className="lpt-group-146">
          <div className="lpt-plan">
            <div className="lpt-overlap-group2-7">
            </div>
          </div>
          <div className="lpt-text-6 lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">
            Our Customer Value Propositions
          </div>
          <p className="lpt-text-7 lpt-typography-body-smalltext-14-regular">
            When it comes to building a new residential or commercial building, choosing the right partner to bring your
            vision to life is an important first step. Our experienced Webuildd team has all the expertise, resources,
            and connections you need to turn inspiration into reality with seamless ease. You don’t have to deal with
            the hassles of managing complex coordination and multiple resources. Our in-house team has you covered from
            legal, estimation, site planning, architectural design,
          </p>
        </div>
        </div>

        {/* <div style={{position:'relative', display: 'flex', flexDirection: 'column',alignItems:'center'}}> */}
        <div className="lpt-frame-154">
          <div className="lpt-our-projects lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">Our Projects</div>
          <p className="lpt-text-10 lpt-typography-body-smalltext-14-regular">
            We offer an entire array of construction options. Choose from basic to luxury according to your requirements
          </p>
          <Frame149 {...frame149Data} />
        </div>
        {/* </div> */}

        
        

       <div style={{position:'relative', display: 'flex', flexDirection: 'column',alignItems:'center',width:'100%',marginTop:'20px'}}>
       <div className="lpt-testimonials lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">Testimonials</div>
              <p className="lpt-text-26 lpt-typographybody16-regular">
                Listen to what our customers say about us. They are the beating heart of our business
              </p>
              <div className="lpt-frame-166">
            <div className="lpt-overlap-group3-2">
              <div className="lpt-frame-160">
                <div className="lpt-frame-159">
                  <div className="lpt-frame-37">
                    <img
                      className="lpt-frame-36"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-36-3@1x.svg"
                    />
                    <img
                      className="lpt-frame-64"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-64-3@1x.svg"
                    />
                    <img
                      className="lpt-frame-65"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                    <img
                      className="lpt-frame-2"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/frame-65@1x.png"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        <CardCarousel />
        </div>
        <MultiCarousel/>
        <Footer />
      </div>
    </div>
  );
}

export default App;

function Frame144(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="lpt-frame-144">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="lpt-group-86">
      <White src={whiteProps.src} />
      <img className="lpt-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="lpt-white">
      <img className="lpt-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="lpt-icon-menu">
      <img
        className="lpt-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="lpt-vector-1" src={vector2} />
      <img className="lpt-vector-1" src={vector3} />
    </div>
  );
}


function GetAQuoteButton2(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x26013033TimelineData);
  }, []);

  return (
    <div className="lpt-x26013033 lpt-component lpt-component-wrapper not-ready">
      <div className="lpt-master-button-Y0gomr">
        <div className="lpt-button-i2601303351-0VL8Sj lpt-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x26013033TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".x26013033",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function Frame149(props) {
  const {
    apartments,
    buildiings,
    group139Props,
    frame138Props,
    group13022Props,
    group135Props,
    group1352Props,
    group135Props2,
    group137Props,
    group135Props3,
    group1352Props2,
    group1372Props,
  } = props;

  return (
    // <div className="lpt-frame-149">
    //   <div className="lpt-frame-1609">
    //     <Group139>{group139Props.children}</Group139>
    //     <div className="lpt-apartments lpt-typographybodycaption-14-semi-bold">{apartments}</div>
    //     <div className="lpt-buildiings lpt-typographybodycaption-14-semi-bold">{buildiings}</div>
    //     <Frame138 place={frame138Props.place} living={frame138Props.living} />
    //   </div>
    //   <div className="lpt-frame-15">
    //     <Group13022
    //       rectangle62={group13022Props.rectangle62}
    //       text107={group13022Props.text107}
    //       surname={group13022Props.surname}
    //     />
    //     <Group135
    //       rectangle62={group135Props.rectangle62}
    //       text108={group135Props.text108}
    //       surname={group135Props.surname}
    //     />
    //   </div>
    //   <div className="lpt-frame-15">
    //     <Group135
    //       rectangle62={group1352Props.rectangle62}
    //       text108={group1352Props.text108}
    //       surname={group1352Props.surname}
    //       className={group1352Props.className}
    //     />
    //     <Group135
    //       rectangle62={group135Props2.rectangle62}
    //       text108={group135Props2.text108}
    //       surname={group135Props2.surname}
    //     />
    //   </div>
    //   <div className="lpt-frame-15-1">
    //     <Group137
    //       rectangle62={group137Props.rectangle62}
    //       text111={group137Props.text111}
    //       surname={group137Props.surname}
    //     />
    //     <Group135
    //       rectangle62={group135Props3.rectangle62}
    //       text108={group135Props3.text108}
    //       surname={group135Props3.surname}
    //     />
    //   </div>
    //   <div className="lpt-frame-15-1">
    //   <Group137
    //       rectangle62={group1372Props.rectangle62}
    //       text111={group1372Props.text111}
    //       surname={group1372Props.surname}
    //       className={group1372Props.className}
    //     />
    //     <Group135
    //       rectangle62={group1352Props2.rectangle62}
    //       text108={group1352Props2.text108}
    //       surname={group1352Props2.surname}
    //       className={group1352Props2.className}
    //     />
        
    //   </div>
    // </div>
    <ProjectCard/>
  );
}


function Group139(props) {
  const { children } = props;

  return (
    <div className="lpt-group-139">
      <div className="lpt-overlap-group2">
        <div className="lpt-rectangle-46"></div>
        <div className="lpt-price lpt-overpass-extra-bold-shark-14px">{children}</div>
      </div>
    </div>
  );
}


function Frame138(props) {
  const { place, living } = props;

  return (
    <div className="lpt-frame-138">
      <div className="lpt-place lpt-typographybodycaption-14-semi-bold">{place}</div>
      <div className="lpt-living lpt-typographybodycaption-14-semi-bold">{living}</div>
    </div>
  );
}


function Group13022(props) {
  const { rectangle62, text107, surname } = props;

  return (
    <div className="lpt-group-130">
      <img className="lpt-rectangle-62" src={rectangle62} />
      <div className="lpt-group-99">
        <div className="lpt-text-11 lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">{text107}</div>
        <p className="lpt-surname lpt-typography-body-smalltext-14-regular">{surname}</p>
      </div>
    </div>
  );
}


function Group135(props) {
  const { rectangle62, text108, surname, className } = props;

  return (
    <div className={`lpt-group-13 ${className || ""}`}>
      <img className="lpt-rectangle-62-1" src={rectangle62} />
      <div className="lpt-group-99-1">
        <div className="lpt-text-1 lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">{text108}</div>
        <p className="lpt-surname-1 lpt-typography-body-smalltext-14-regular">{surname}</p>
      </div>
    </div>
  );
}


function Group137(props) {
  const { rectangle62, text111, surname, className } = props;

  return (
    <div className={`lpt-group-137 ${className || ""}`}>
      <img className="lpt-rectangle-62-2" src={rectangle62} />
      <div className="lpt-group-99-2">
        <div className="lpt-text-1-1 lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">{text111}</div>
        <p className="lpt-surname-2 lpt-typography-body-smalltext-14-regular">{surname}</p>
      </div>
    </div>
  );
}


function Button22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x26013224TimelineData);
  }, []);

  return (
    <div className="lpt-x26013224 lpt-component lpt-component-wrapper not-ready">
      <div className="lpt-master-button-KTVw70">
        <div className="lpt-button-i2601322451-i3uVbP lpt-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x26013224TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".x26013224",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function PackagesCard(props) {
  const { basic, group69Props, buttonProps } = props;

  return (
    <div className="lpt-package-card">
      <div className="lpt-basic lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">{basic}</div>
      <div className="lpt-basic-1">
        <img
          className="lpt-vector-3"
          src="../../Images/Home_Page/Img/Icons/Packages/Basic.svg"
        />
      </div>
      <Group69 number={group69Props.number} text4={group69Props.text4} />
      <Button8><Link to="/packagedetails">{buttonProps.children}</Link></Button8>
    </div>
  );
}


function Group69(props) {
  const { number, text4 } = props;

  return (
    <div className="lpt-group-69">
      <h1 className="lpt-number lpt-valign-text-middle lpt-typographyheadlineh2-extrabold-40">{number}</h1>
      <div className="lpt-rs-sft lpt-valign-text-middle lpt-typographybody16-regular">{text4}</div>
    </div>
  );
}


function Button8(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x26013055TimelineData);
  }, []);

  return (
    <div className="lpt-x26013055 lpt-component lpt-component-wrapper not-ready">
      <div className="lpt-master-button-bEwMED">
        <div className="lpt-button-i2601305551-fEuPhW lpt-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x26013055TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".x26013055",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function Group1112(props) {
  const { place, overlapGroup4, group69Props, buttonProps } = props;

  return (
    <div className="lpt-package-card-1">
      <div className="lpt-place-1 lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">{place}</div>
      <div className="lpt-standard">
        <div className="lpt-overlap-group2-1" style={{ backgroundImage: `url(${overlapGroup4})` }}> 
          {/* <img
            className="lpt-vector-4"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-79@2x.svg"
          /> */}
        </div>
      </div>
      <Group69 number={group69Props.number} text4={group69Props.text4} />
      <Button8><Link to="/packagedetails">{buttonProps.children}</Link></Button8>
          </div>
  );
}


function Group112(props) {
  const { premium, group, vector2, vector3, vector4, group2, group69Props, buttonProps } = props;

  return (
    <div className="lpt-package-card-2">
      <div className="lpt-premium lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">{premium}</div>
      <div className="lpt-premium-1">
        <div className="lpt-overlap-group2-2">
          <div className="lpt-group" style={{ backgroundImage: `url(${group})` }}></div>
          {/* <img
            className="lpt-vector-5"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-81@2x.svg"
          />
          <img className="lpt-vector-6" src={vector2} />
          <img className="lpt-vector-7" src={vector3} />
          <img className="lpt-vector-8" src={vector4} />
          <div className="lpt-group-1" style={{ backgroundImage: `url(${group2})` }}></div> */}
        </div>
      </div>
      <Group69 number={group69Props.number} text4={group69Props.text4} />
      <Button8><Link to="/packagedetails">{buttonProps.children}</Link></Button8>
    </div>
  );
}


function Group113(props) {
  const { basic, group69Props, buttonProps } = props;

  return (
    <div className="lpt-package-card-3">
      <div className="lpt-basic-2 lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">{basic}</div>
      <div className="lpt-luxury">
        {/* <img
          className="lpt-vector-9"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/icons-2@2x.svg"
        /> */}
         <img
          className="lpt-vector-9"
          src="../../Images/Home_Page/Img/Icons/Packages/Luxury.svg"
        />
      </div>
      <Group69 number={group69Props.number} text4={group69Props.text4} />
      <Button8><Link to="/packagedetails">{buttonProps.children}</Link></Button8>
    </div>
  );
}


function Group11422(props) {
  const { costEstimator, text93 } = props;

  return (
    <div className="lpt-group-114">
      <div className="lpt-cost-estimator lpt-valign-text-middle lpt-typographyheadlineh4-extrabold-24">{costEstimator}</div>
      <p className="lpt-text-20 lpt-valign-text-middle lpt-typographybodysmall-12-regular">{text93}</p>
    </div>
  );
}


function EstimateNowButton(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x26013220TimelineData);
  }, []);

  return (
    <div className="lpt-x26013220 lpt-component lpt-component-wrapper not-ready">
      <Link to="/">
        <div className="lpt-master-button-8PZClG">
          <div className="lpt-button-i2601322051-Sid1RS lpt-valign-text-middle">{children}</div>
        </div>
      </Link>
    </div>
  );
}

const x26013220TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".lpt-x26013220",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {
          "": {
            position: "relative",
          },
        },
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {
          "": {
            position: "relative",
          },
        },
      },
    },
  },
];


function Group11722(props) {
  const { frame12Props, frame122Props } = props;

  return (
    <div className="lpt-group-117">
      <CostEstimate />
      {/* <Frame122>{frame12Props.children}</Frame122>
      <Frame122 className={frame122Props.className}>{frame122Props.children}</Frame122> */}
    </div>
  );
}


function Frame122(props) {
  const { children, className } = props;

  return (
    <div className={`lpt-frame-1 lpt-border-1px-white ${className || ""}`}>
      <div className="lpt-text-21 lpt-inter-normal-white-14px">{children}</div>
    </div>
  );
}


function Group2722(props) {
  const { text120, ellipse1, name, bangaloreIndia, className } = props;

  return (
    <div className={`lpt-group-27 ${className || ""}`}>
      <div className="lpt-overlap-group">
        <p className="lpt-text-2 lpt-typographybodysmall-12-regular">{text120}</p>
        <div className="lpt-group-120">
          <img className="lpt-ellipse-1" src={ellipse1} />
          <div className="lpt-group-140">
            <div className="lpt-name lpt-valign-text-middle lpt-typographyheadlineh5-extrabold-20">{name}</div>
            <div className="lpt-bangalore-india lpt-valign-text-middle lpt-typographybodysmall-12-regular">{bangaloreIndia}</div>
          </div>
        </div>
      </div>
    </div>
  );
}


function Group129() {
  return (
    <div className="lpt-group-141">
      <div className="lpt-ellipse-99"></div>
      <div className="lpt-ellipse-10"></div>
      <div className="lpt-ellipse-10"></div>
    </div>
  );
}


function Frame165(props) {
  const { image3, image5, image4, image6, image8, image7 } = props;

  return (
    <div className="lpt-frame-165">
      {/* <img className="lpt-image-3" src={image3} />
      <img className="lpt-image" src={image5} />
      <img className="lpt-image" src={image4} />
      <img className="lpt-image" src={image6} />
      <img className="lpt-image" src={image8} />
      <img className="lpt-image" src={image7} /> */}

      <img className="lpt-image-3" src={home_page.GreyBG1} />
      <img className="lpt-image" src={home_page.GreyBG2} />
      <img className="lpt-image" src={home_page.GreyBG3} />
      <img className="lpt-image" src={home_page.GreyBG4} />
      <img className="lpt-image" src={home_page.GreyBG5} />
      <img className="lpt-image" src={home_page.GreyBG6} />
    </div>
  );
}


// function Footer(props) {
//   const {
//     group85,
//     place,
//     overlapGroup,
//     vector2,
//     phone,
//     overlapGroup1,
//     vector3,
//     text42,
//     text3,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//     group87Props,
//   } = props;

//   return (
//     <div className="lpt-footer">
//       <div className="lpt-flex-row-1">
//         <img
//           className="lpt-vector-10"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
//         />
//         <img className="lpt-group-85-1" src={group85} />
//         <Group87
//           facebookAppSymbolProps={group87Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group87Props.facebookAppSymbolProps2}
//           twitterProps={group87Props.twitterProps}
//         />
//       </div>
//       <div className="lpt-flex-row-2">
//         <div className="lpt-group-32">
//           <div className="lpt-place-2 lpt-valign-text-middle lpt-typographyheadlineh5-extrabold-20">{place}</div>
//           <div className="lpt-flex-row-3">
//             <div className="lpt-flex-col">
//               <div className="lpt-map-pin-1">
//                 <div className="lpt-overlap-group2-3" style={{ backgroundImage: `url(${overlapGroup})` }}>
//                   <img className="lpt-vector-11" src={vector2} />
//                 </div>
//               </div>
//               <div className="lpt-phone" style={{ backgroundImage: `url(${phone})` }}></div>
//               <div className="lpt-mail">
//                 <div className="lpt-overlap-group3" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="lpt-vector-12" src={vector3} />
//                 </div>
//               </div>
//             </div>
//             <div className="lpt-flex-col-1">
//               <p className="lpt-text-23 lpt-typography-body-smalltext-14-regular">{text42}</p>
//               <div className="lpt-flex-col-item lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">{text3}</div>
//               <div className="lpt-flex-col-item lpt-valign-text-middle lpt-typography-body-smalltext-14-regular">
//                 {contactWebuildCom}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="lpt-group-147">
//           <div className="lpt-quick-links lpt-valign-text-middle lpt-typographyheadlineh5-extrabold-20">{quickLinks}</div>
//           <div className="lpt-flex-row-4">
//             <div className="lpt-about-us lpt-valign-text-middle lpt-typographybody16-regular">{aboutUs}</div>
//             <div className="lpt-projects lpt-valign-text-middle lpt-typographybody16-regular">{projects}</div>
//           </div>
//           <div className="lpt-flex-row">
//             <div className="lpt-gallery lpt-valign-text-middle lpt-typographybody16-regular">{gallery}</div>
//             <div className="lpt-knowledge-transfer lpt-valign-text-middle lpt-typographybody16-regular">{knowledgeTransfer}</div>
//           </div>
//           <div className="lpt-flex-row">
//             <div className="lpt-blogs lpt-valign-text-middle lpt-typographybody16-regular">{blogs}</div>
//             <div className="lpt-fa-qs lpt-valign-text-middle lpt-typographybody16-regular">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


function Group87(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="lpt-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram instagram={facebookAppSymbolProps2.instagram} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="lpt-facebook-app-symbol">
      <img className="lpt-f-1" src={src} />
    </div>
  );
}


function Instagram(props) {
  const { instagram, vector2 } = props;

  return (
    <div className="lpt-instagram" style={{ backgroundImage: `url(${instagram})` }}>
      <div className="lpt-overlap-group2-4">
        <img
          className="lpt-vector-13"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg"
        />
        <img className="lpt-vector-14" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="lpt-twitter">
      <img className="lpt-vector-15" src={src} />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame144Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const group139Data = {
    children: "ALL",
};

const frame138Data = {
    place: "INTERIOR",
    living: "LIVING",
};

const group13022Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-33@2x.png",
    text107: "Project Name",
    surname: "Small description about the project",
};

const group135Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-34@2x.png",
    text108: "Project Name",
    surname: "Small description about the project",
};

const group1352Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-35@2x.png",
    text108: "Project Name",
    surname: "Small description about the project",
    className: "lpt-group-13-1",
};

const group1353Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-36@2x.png",
    text108: "Project Name",
    surname: "Small description about the project",
};

const group137Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-37@2x.png",
    text111: "Project Name",
    surname: "Small description about the project",
};

const group1354Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-38@2x.png",
    text108: "Project Name",
    surname: "Small description about the project",
};

const group1355Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-39@2x.png",
    text108: "Project Name",
    surname: "Small description about the project",
    // className: "lpt-group-13-1",
};

const group1372Data = {
    rectangle62: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-62-40@2x.png",
    text111: "Project Name",
    surname: "Small description about the project",
    // className: "lpt-group-133",
};

const frame149Data = {
    apartments: "APARTMENTS",
    buildiings: "BUILDIINGS",
    group139Props: group139Data,
    frame138Props: frame138Data,
    group13022Props: group13022Data,
    group135Props: group135Data,
    group1352Props: group1352Data,
    group135Props2: group1353Data,
    group137Props: group137Data,
    group135Props3: group1354Data,
    group1352Props2: group1355Data,
    group1372Props: group1372Data,
};

const group69Data = {
    number: "1600",
    text4: "Rs/Sft",
};

const button8Data = {
    children: "VIEW DETAILS",
};

const packagesCardData = {
    group69Props: group69Data,
    buttonProps: button8Data,
};

const group692Data = {
    number: "1600",
    text4: "Rs/Sft",
};

const button82Data = {
    children: "VIEW DETAILS",
};

const group1112Data = {
    group69Props: group692Data,
    buttonProps: button82Data,
};

const group693Data = {
    number: "1600",
    text4: "Rs/Sft",
};

const button83Data = {
    children: "VIEW DETAILS",
};

const group112Data = {
    premium: "Premium",
    group: "../../Images/Home_Page/Img/Icons/Packages/Premium.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-82@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-83@2x.svg",
    vector4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-145@2x.svg",
    group2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-146@2x.svg",
    group69Props: group693Data,
    buttonProps: button83Data,
};

const group694Data = {
    number: "1600",
    text4: "Rs/Sft",
};

const button84Data = {
    children: "VIEW DETAILS",
};

const group113Data = {
    group69Props: group694Data,
    buttonProps: button84Data,
};

const frame122Data = {
    children: "City",
};

const frame1222Data = {
    children: "Area of Construction (Sq.ft)",
    className: "lpt-frame-1-1",
};

const group11722Data = {
    frame12Props: frame122Data,
    frame122Props: frame1222Data,
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagramData = {
    instagram: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-223@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-409@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-347@2x.svg",
};

const group87Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagramData,
    twitterProps: twitterData,
};

// const footerData = {
//     group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg", 
//     place: "Contact",
//     overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-374@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-150@2x.svg",
//     phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-151@2x.svg",
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-264@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg",
//     text42: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
//     text3: "+91 8976535221, +91 8755645342",
//     contactWebuildCom: "contact@webuild.com",
//     quickLinks: "Quick Links",
//     aboutUs: "About Us",
//     projects: "Projects",
//     gallery: "Gallery",
//     knowledgeTransfer: "Knowledge Transfer",
//     blogs: "Blogs",
//     faqs: "FAQ’s",
//     group87Props: group87Data,
// };

